import WidgetModule from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsProductList";

export * from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsProductList";

export default WidgetModule;
